import React, { useState, useEffect } from 'react'
import Loader from './shared/Loader'
import { validateEmail, showFlashMessage } from '../helpers/utils'

export default function Login({ formPath, emailValue, passwordAutocomplete, refParams, rememberable, passwordSuccessMessage, termsUrl, privacyUrl, addendumUrl }) {
  const [email, setEmail]                             = useState(emailValue)
  const [password, setPassword]                       = useState('')
  const [rememberMe, setRememberMe]                   = useState(false)
  const [loading, setLoading]                         = useState(false)
  const [passwordShown, setPasswordShown]             = useState(false)

  const disableSubmit = !(password.length && validateEmail(email))

  useEffect(() => {
    if(passwordSuccessMessage) {
      showFlashMessage(passwordSuccessMessage, 'success')
    }
  }, [])

  function handleSubmit(event) {
    event.preventDefault()

    if (email.length === 0) {
      showFlashMessage(Cas.translations.email_blank, 'error')

    } else if (!validateEmail(email)) {
      showFlashMessage(Cas.translations.email_invalid, 'error')

    } else if (disableSubmit) {
      showFlashMessage(Cas.translations.password_validation_alert, 'error')

    } else {
      save()
    }
  }

  function save(event) {
    setLoading(true)

    let formData = new FormData()
    formData.append('account[email]', email)
    formData.append('account[password]', password)
    if(rememberMe) {
      formData.append('account[remember_me]', rememberMe)
    }

    for(const refParamKey in refParams) {
      formData.append(refParamKey, refParams[refParamKey])
    }

    Rails.ajax({
      type: 'POST',
      url: formPath,
      dataType: 'json',
      data: formData,
      success: res => {
        if (res.redirectUrl) {
          window.location.href = res.redirectUrl
        } else {
          setLoading(false)
        }
      },
      error: res => {
        showFlashMessage(res.error, 'error')
        setLoading(false)
      }
    })
  }

  return (
    <>
      <div className='field'>
        <label>
          { Cas.translations.email }
        </label>
        <input
          type='email'
          autoFocus
          autoComplete='email'
          placeholder='some@example.com'
          value={ email }
          onChange={ event => setEmail(event.target.value) }
        />
      </div>

      <div className='field' style={{ position: 'relative' }}>
        <label>
          { Cas.translations.password }
        </label>
        <input
          type={ passwordShown ? "text" : "password" }
          autoFocus
          autoComplete={ passwordAutocomplete }
          value={ password }
          onChange={ event => setPassword(event.target.value) }
        />
        { password.length > 0 &&
          <div className='show_password'>
            <i className={`pointer fa-light ${passwordShown ? 'fa-eye-slash' : 'fa-eye' }`} onClick={ ()=> setPasswordShown(prevState => !prevState) } />
          </div>
        }
      </div>

      { rememberMe &&
        <div className="field flex-box items-center">
          <input type="checkbox" id="remember_me" name="remember_me" />
          <div style={{ fontWeight: 300 }}>{ Cas.translations.remember_me }</div>
        </div>
      }

      <div className='actions'>
        { !loading ?
          <div className='flex-box items-center content-center'>
            <button type='submit' className={`button ${disableSubmit ? 'disabled' : ''}`} onClick={ handleSubmit }>
              { Cas.translations.login  }
            </button>
          </div>
          :
          <div className='flex-box content-center'>
            <Loader size='small' position='centered'/>
          </div>
        }
      </div>
    </>
  )
}
